import api, { API_BASE_URL } from './api';

// Auth API endpoints
export const authService = {
  /**
   * Send registration OTP codes (does not create user account)
   * @param {Object} userData - { email, password, phone }
   * @returns {Promise}
   */
  sendRegistrationOtp: async (userData) => {
    return api.post('/send-registration-otp', userData);
  },

  /**
   * Login user
   * @param {Object} credentials - { email, password }
   * @returns {Promise}
   */
  login: async (credentials) => {
    const response = await api.post('/login', credentials);
    // Store token in localStorage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  /**
   * Logout user
   */
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refresh_token');
  },

  /**
   * Verify email with code
   * @param {Object} data - { email, code }
   * @returns {Promise}
   */
  verifyEmail: async (data) => {
    return api.post('/verify-email', data);
  },

  /**
   * Resend email verification code
   * @param {Object} data - { email, phone }
   * @returns {Promise}
   */
  resendEmailCode: async (data) => {
    return api.post('/resend-email-code', data);
  },

  /**
   * Verify phone with code (creates user account)
   * @param {Object} data - { email, phone, code }
   * @returns {Promise}
   */
  verifyPhone: async (data) => {
    const response = await api.post('/verify-phone', data);
    // Store token if provided (phone verification completes registration)
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  /**
   * Resend phone verification code
   * @param {Object} data - { email, phone }
   * @returns {Promise}
   */
  resendPhoneCode: async (data) => {
    return api.post('/resend-phone-code', data);
  },

  /**
   * Get current user (requires authentication)
   * @returns {Promise}
   */
  getCurrentUser: async () => {
    return api.get('/user');
  },

  /**
   * Check if user is authenticated
   * @returns {boolean}
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  /**
   * Get stored user data
   * @returns {Object|null}
   */
  getStoredUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },
};

export default authService;
